import {MyOrganization} from "../../../../services/my-organization-service"
import {LoginSettingType} from "../../../../services/organization-service"

export const isOrganizationRequiresPhoneNumber = (myOrganization: MyOrganization): boolean =>
  myOrganization.loginSettings.find(setting => setting.type === LoginSettingType.DeviceVerification) !== undefined